import CONFIG from '../config/config';
import { instanceWithV2 as instance } from './SimpleAPIClient';
import { MeetingType } from "../shared/meetingTypeToTranslationKey";

export interface BookingPlan {
  id?: number;
  name: string;
  internalType: MeetingType;
  customerInfo: string;
  automaticallyAccept: boolean;
  requiresFee: boolean;
  enabled: boolean;
  duration: string;
  price?: number;
  useCalendarAvailability: boolean;
  weekdayHours: Record<string, WeekdayHours>;
  customerData: CustomerData;
  budgetRanges: {min: number, max: number}[]
  brideCanCancel?: boolean;
  requiresRefundableFee: boolean;
  refundableFee?: number;
  refundableFeeCurrency?: string;
  useAdditionalRestrictions: boolean;
  startDate?: string;
  endDate?: string;
  minimumAdvanceBookingDays?: number;
  maximumAdvanceBookingDays?: number;
  useOnlinePayments: boolean;
  feeIsDeposit?: boolean;
  useDisabledDates?: boolean;
  disabledDates?: { startDate: string; endDate: string }[];
  useEnabledDates?: boolean;
  enabledDates?: { startDate: string; endDate: string }[];
  displayOrder?: number;
}

export interface WeekdayHours {
  enabled: boolean;
  opening: string;
  closing: string;
}

export interface CustomerData {
  requestEmail: boolean;
  requestPhone: boolean;
  requestName: boolean;
  requestBudget: boolean;
  requestSize: boolean;
  requestWeddingDate: boolean;
  requestNumberOfPeople: boolean;
  allowSpecialComments: boolean;
  requestWhereHeardFrom: boolean;
}

type BookingPlanResponse = BookingPlan;
type BookingPlansResponse = BookingPlan[];

const BookingPlansAPI = {
  getAll: () => {
    return instance(CONFIG.API_ENDPOINT).get<BookingPlansResponse>('v1/booking-plans');
  },
  getById: (id: number) => {
    return instance(CONFIG.API_ENDPOINT).get<BookingPlanResponse>(`v1/booking-plans/${id}`);
  },
  create: (bookingPlan: BookingPlan) => {
    return instance(CONFIG.API_ENDPOINT).post<BookingPlanResponse>('v1/booking-plans', bookingPlan);
  },
  update: (id: number, bookingPlan: BookingPlan) => {
    return instance(CONFIG.API_ENDPOINT).put<BookingPlanResponse>(`v1/booking-plans/${id}`, bookingPlan);
  },
  delete: (id: number) => {
    return instance(CONFIG.API_ENDPOINT).delete<void>(`v1/booking-plans/${id}`);
  },
  setBookingLink: (alias: string) => {
    return instance(CONFIG.API_ENDPOINT).post<string>('v1/booking-plans/alias', { alias });
  },
  checkAliasAvailability: (alias: string, signal?: AbortSignal) => {
    return instance(CONFIG.API_ENDPOINT).post<string>('v1/booking-plans/alias/check', { alias }, { signal });
  },
  reorder: (orderedIds: number[]) => {
    return instance(CONFIG.API_ENDPOINT).put<void>('v1/booking-plans/reorder', orderedIds);
  },
};

export default BookingPlansAPI;